module dg.modules.users {

    export class UsersService {

        //private refreshCurrentUserCommands = ['user_UpdateMyProfile', 'user_Update', 'userTask_ChangeUserTaskStatus'];
        constructor(private $q: ng.IQService,
            private actionService: dg.actions.ActionService,
            private $rootScope: ng.IRootScopeService) {

            //let stopUserDetailsChangeWatcher = $rootScope.$on(dg.restfulApi.DG_EVENTS.commandSuccessfullyExecuted,
            //    this.reloadCurrentUserWhenUpdated);
            //$rootScope.$on("$destroy", stopUserDetailsChangeWatcher);
        }

        //Fake User
        //$rootScope.userInfo = {
        //    isAuthenticated: true,
        //    userName: 'ivan-ivanov@icm.bg',
        //    profile: null
        //};

        currentUser: IUser;

        public reloadCurrentUser() {
            let defer = this.$q.defer<IUser>();
            this.actionService.getQueryResult('/user/current/result')
                .then(user => {
                    this.currentUser = dgUtils.ObjectHelperService.mergeDeep(this.currentUser, user);
                    defer.resolve(this.currentUser);
                },
                defer.reject);

            return defer.promise;
        }

        public getCurrentUser() {

            if (this.currentUser) {

                let defer = this.$q.defer<IUser>();
                defer.resolve(this.currentUser);
                return defer.promise;
            }
            else {
                return this.reloadCurrentUser();
            }
        }

        public getLoadedCurrentUser() {
            return this.currentUser;
        }
        //reloadCurrentUserWhenUpdated(event: ng.IAngularEvent, command: any) {
        //    if (!!command
        //        && this.refreshCurrentUserCommands.indexOf(command.dgMeta.id) >= 0
        //        && command.userName == this.currentUser.userName) {

        //        //reload user data in case user profile is changed ot tasks are updated
        //        this.reloadCurrentUserData();
        //    }
        //}
    }

    angular.module('dg.modules.users')
        .service('usersService', UsersService);
} 